var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 181,
    viewBox: "0 0 189 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.4578 2.12628C110.776 -3.45418 131.101 2.62117 147.504 12.5492C164.865 23.0573 179.288 38.9804 185.448 58.4095C191.59 77.7833 189.582 99.4059 180.856 117.747C172.753 134.778 155.075 143.477 139.778 154.403C124.69 165.18 110.881 182.57 92.4578 180.886C74.1318 179.212 65.8803 157.179 50.992 146.291C36.1008 135.401 13.6907 133.867 5.48304 117.282C-2.97016 100.2 -1.54908 77.3648 9.0539 61.5453C19.13 46.5119 42.5477 50.5189 57.2521 40.043C71.6317 29.7986 75.5972 7.26262 92.4578 2.12628Z",
    fill: "#0896E4",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueVector);
export default __webpack_public_path__ + "static/media/blueVector.e50cdb09f54d7555e5ef990c238e826f.svg";
export { ForwardRef as ReactComponent };